import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Image,
  useBreakpointValue,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { Navbar } from './Navbar';
import { useSidebar } from '../../hooks/useSidebar';
import { ROUTER_PATHS } from '../../constants';
import logo from '../../assets/logo-service-gray.png';

export const Sidebar: React.VFC = () => {
  const { isOpen, onClose } = useSidebar();

  const isDrawerSidebar = useBreakpointValue({
    base: true,
    lg: false,
  });

  if (isDrawerSidebar) {
    return (
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        closeOnEsc
        closeOnOverlayClick
      >
        <DrawerOverlay>
          <DrawerContent
            bg="gray.100"
            p="4"
            borderRight="1px solid"
            borderColor="gray.300"
          >
            <DrawerCloseButton mt="6" />
            <DrawerHeader>
              <Link to={ROUTER_PATHS.PORTAL.HOME}>
                <Image src={logo} maxW="12rem" />
              </Link>
            </DrawerHeader>
            <DrawerBody>
              <Navbar />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    );
  }

  return (
    <Flex
      maxWidth="240px"
      w={isOpen ? '100%' : '50'}
      bg="gray.100"
      borderRight="1px solid"
      borderColor="gray.300"
      p={4}
      overflowX="auto"
    >
      <Navbar />
    </Flex>
  );
};
